import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormService } from '@core/services';
import { ErrorModel, OrderOnRentDamageModel } from '@core/api';
import { DialogForm } from '@core/components/abstract/dialog-form';
import { finalize } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'modal-trailer-defect',
  templateUrl: './modal-trailer-defect.component.html',
  styleUrls: ['./modal-trailer-defect.component.scss']
})
export class ModalTrailerDefectComponent implements OnInit, DialogForm {

  form: FormGroup;
  loading: boolean = false;

  @Output() updateData = new EventEmitter<null>();

  constructor(
    public dialogRef: MatDialogRef<ModalTrailerDefectComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OrderOnRentDamageModel,
    private formBuilder: FormBuilder,
    private formService: FormService
  ) {
    this.form = this.formBuilder.group({
      comment: [null, [Validators.required]],
      // images: [null]
    });
  }

  updateHandler(fn: (defect: OrderOnRentDamageModel) => Observable<OrderOnRentDamageModel>) {
    this.loading = true;

    fn(this.form.value)
      .pipe(finalize(() => this.loading = false))
      .subscribe(
        () => this.success(),
        (e) => this.error(e)
      );
  }

  error(error: ErrorModel): void {
    this.formService.serverValidateForm(this.form, error);
  }

  success(): void {
    this.dialogRef.close(true);
  }

  finalize(): void {
    this.loading = false;
  }

  emitData(): void {
    this.formService.markFormGroupTouched(this.form);

    if (this.form.invalid) {
      return void 0;
    }

    this.updateData.emit();
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  ngOnInit() {
  }

}
